import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  faTimes,
  faAsterisk,
  faSave,
  faTrash,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { gradeData1 } from "../../../constants/data";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import Storage from "../../../services/Storage";
import swal from "sweetalert";
import { Modal, ModalBody } from "reactstrap";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { startImpersonation } from "../../../reducers/ImpersonationReducer";
import { userInfoAction } from "../../../reducers/UserReducer";

const StudentModal = ({ isOpen, setIsOpen, data }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} centered={true}>
        <ModalBody>
          <div style={{ textAlign: "center" }}>
            <p>{data.message}</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={data.function1}
                style={{
                  backgroundColor: "#009900",
                  color: "white",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginRight: "20px",
                  borderRadius: "5px",
                }}
              >
                <FontAwesomeIcon
                  style={{ margin: "0 5px" }}
                  color="white"
                  icon={faCheck}
                />
                Ok
              </button>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  backgroundColor: "#efefef",
                  color: "black",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginLeft: "20px",
                  borderRadius: "5px",
                }}
              >
                <FontAwesomeIcon style={{ margin: "0 5px" }} icon={faTimes} />
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

const CreateStudent = ({
  setOpenCreateStudent,
  modify,
  school_id,
  getStudentwithId,
  getCounselor,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.UserReducer.userObj);
  const counselorRef = useRef();
  const timeoutRef = useRef();
  const activitiesRef = useRef();
  const athleticsRef = useRef();
  const timeout = useRef();
  const [grade, setGrade] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [showCounselorContainer, setShowCounselorContainer] = useState(false);
  const [showActivitiesContainer, setShowAtivitiesContainer] = useState(false);
  const [activitiesList, setActivitiesList] = useState();
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [showAthleticsContainer, setShowAthleticsContainer] = useState(false);
  const [athleticsList, setAthleticsList] = useState();
  const [selectedAthletics, setSelectedAthletics] = useState([]);
  const [counselorList, setCounselorList] = useState([]);
  const [counselorName, setCounselorName] = useState("");
  const [selectedCounselor, setSelectedCounselor] = useState();
  const [email, setEmail] = useState();
  const [parentEmail, setParentEmail] = useState();
  const [recoveryEmail, setRecoveryEmail] = useState();
  const [mobile, setMobile] = useState();
  const [parentMobile, setParentMobile] = useState();
  const [parentName, setParentName] = useState();
  const [activities, setActivities] = useState();
  const [athletics, setAthletics] = useState();
  const [firstInFamily, setFirstInFamily] = useState(false);
  const [agreeToshare, setAgreeToshare] = useState(true);
  const [showPasswordError, setShowPasswordError] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openMergeModal, setOpenMergeModal] = useState(false);
  const [searchMergeStudent, setSearchMergeStudent] = useState();
  const [mergeStudentId, setMergeStudentId] = useState();
  const [mergeStudentList, setMergeStudentList] = useState();

  const modifyData = () => {
    setSearchMergeStudent("");
    setFirstName(modify?.student?.first_name);
    setLastName(modify?.student?.last_name);
    setGrade(modify?.student?.current_grade);
    setEmail(modify?.student?.email);
    setMobile(modify?.student?.mobile);
    setParentEmail(modify?.student?.parent_email);
    setParentName(modify?.student?.parent_name);
    setParentMobile(modify?.student?.parent_mobile);
    setRecoveryEmail(modify?.student?.recovery_email);
    if (modify?.counselor) setSelectedCounselor(modify?.counselor);
    else setSelectedCounselor();
    setFirstInFamily(modify?.student?.student_first_gen);
    setAgreeToshare(modify?.student?.student_opt_out);
    // if (modify?.selectedactivities_obj) {
    //   let arr = modify?.selectedactivities_obj.map((item) => {
    //     delete item?.id;
    //     return item;
    //   });
    //   setSelectedActivities(arr);
    // } else setSelectedActivities([]);
    // if (modify?.selectedathletics) {
    //   let arr = modify?.selectedathletics.map((item) => {
    //     delete item?.id;
    //     return item;
    //   });
    //   setSelectedAthletics(arr);
    // } else setSelectedAthletics([]);
    };

  useEffect(() => {
    if (modify) {
      modifyData();
    }
  }, [modify]);

  const getObject = () => {
    // let activitiesId = selectedActivities?.map((item) => item.id);
    // let athleticsId = selectedAthletics?.map((item) => item.id);
    let obj = {
      student_opt_out: agreeToshare,
      // selectedactivities_obj: selectedActivities,
      // selectedactivities: activitiesId,
      // selectedathletics: selectedAthletics,
      // selectedathletics: selectedAthletics,
      counselor: selectedCounselor?.id || null,
      current_grade: grade,
      first_name: firstName,
      last_name: lastName,
      email: email,
      parent_email: parentEmail,
      recovery_email: recoveryEmail,
      mobile: mobile,
      parent_mobile: parentMobile,
      parent_name: parentName,
      student_first_gen: firstInFamily,
      user_id: modify?.student?.id,
      type: "student",
    };
    return obj;
  };

  const setNull = () => {
    setSelectedAthletics([]);
    setSelectedActivities([]);
    setSelectedCounselor();
    setGrade("");
    setFirstInFamily(false);
    setAgreeToshare(true);
    setCounselorName("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setRecoveryEmail("");
    setParentEmail("");
    setMobile("");
    setParentMobile("");
    setPassword("");
    setConfirmPassword("");
    setParentName("");
  };

  const saveButtonHandler = () => {
    let obj = getObject();
    obj.password = password;
    obj.password_confirm = confirmPassword;
    obj.school = school_id;
    GetStudentService.saveStudent(obj)
      .then((data) => {
        console.log("data from the service", data);
        setNull();
        getStudentwithId("all");
        setOpenCreateStudent(false);
        swal({
          text: data?.data?.message,
          icon: "success",
          buttons: {
            ok: true,
          },
          closeOnClickOutside: true,
        });
      })
      .catch((error) => {
        console.log("error from the service", error, error?.response);
        swal({
          text: error?.response?.data?.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true,
            confirm: true,
          },
          closeOnClickOutside: true,
        }).then((value) => {
          console.log("value", value);
        });
      });
  };

  const updateButtonHandler = () => {
    let obj = getObject();
    if (password) obj.password = password;
    GetStudentService.updateStudent(obj)
      .then((data) => {
        console.log("student from the service", data);
        setNull();
        getStudentwithId("all");
        setOpenCreateStudent(false);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  const getCounselorName = (value) => {
    GetStudentService.getCounselorName(value, "counselor", school_id)
      .then((data) => {
        console.log("data from the service", data?.data);
        setCounselorList(data?.data?.result);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  const getStudentfromSearchHandler = (q) => {
    let obj = {
      q: q,
      role: "student",
      school: school_id,
    };
    GetStudentService.searchStudent(obj)
      .then((data) => {
        console.log("student from the service", data);
        setMergeStudentList(data.data.result);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  const searchHandler = (e) => {
    let q = e.target.value;
    setSearchMergeStudent(q);
    if (q === "") {
      setMergeStudentList();
    } else {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        getStudentfromSearchHandler(q);
      }, 500);
    }
  };

  const mergeStudent = () => {
    let obj = {
      student_with_id: mergeStudentId,
      student_without_id: modify?.student?.id,
    };
    GetStudentService.mergeStudent(obj)
      .then((data) => {
        // console.log("student from the service", data)
        swal({
          text: data?.data?.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true,
          },
          closeOnClickOutside: true,
        });
        setOpenMergeModal(false);
      })
      .catch((error) => {
        console.log("error from the service", error);
        setOpenMergeModal(false);
      });
  };

  const deleteStudent = () => {
    GetStudentService.deleteStudent(modify?.student?.id)
      .then((data) => {
        console.log("student from the service", data);
        swal({
          text: "Student deleted successfully!",
          icon: "success",
          buttons: {
            OK: true,
          },
          closeOnClickOutside: true,
        }).then((value) => {
          if (value === "OK") {
            window.location.reload();
          }
        });
        setNull();
        getStudentwithId("all");
        setOpenCreateStudent(false);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
    setOpenDeleteModal(false);
  };

  const counselorHandler = () => {
    clearTimeout(timeoutRef.current);
    if (!counselorName) {
      setShowCounselorContainer(false);
      setCounselorList([]);
    }
    setCounselorName(counselorRef.current.value);
    timeoutRef.current = setTimeout(() => {
      getCounselorName(counselorRef.current.value);
    }, 1000);
    setShowCounselorContainer(true);
  };

  const removeCounselorName = (value) => {
    // let filteredValue = selectedCounselor?.filter((item) => item !== value);
    // setSelectedCounselor(filteredValue);
    setSelectedCounselor();
  };

  const handleCounselorSelect = (item) => {
    setCounselorName("");
    // setSelectedCounselor([...selectedCounselor, item]);
    setSelectedCounselor(item);
    setCounselorList([]);
    setShowCounselorContainer(false);
  };

  const passwordValidation = (value) => {
    if (!value || value.length < 8) {
      setShowPasswordError("Password must be at least 8 characters");
      return false;
    }
    // If confirm password is filled, also check if they match
    if (confirmPassword && value !== confirmPassword) {
      setShowPasswordError("Password and Confirm Password should be same.");
      return false;
    }
    setShowPasswordError("");
    return true;
  };

  const confirmPasswordValidation = (value) => {
    // First check if password is valid
    if (!password || password.length < 8) {
      setShowPasswordError("Password must be at least 8 characters");
      return false;
    }
    if (value !== password) {
      setShowPasswordError("Password and Confirm Password should be same.");
      return false;
    }
    setShowPasswordError("");
    return true;
  };

  const handleActivitiesChange = () => {
    clearTimeout(timeoutRef.current);
    setActivities(activitiesRef.current.value);
    if (!activitiesRef.current.value) {
      setShowAtivitiesContainer(false);
      setActivitiesList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getActivities(activitiesRef.current.value);
      }, 1000);
    }
    setShowAtivitiesContainer(true);
  };

  const handleAthleticsChange = () => {
    clearTimeout(timeoutRef.current);
    setAthletics(athleticsRef.current.value);
    if (!athleticsRef.current.value) {
      setShowAthleticsContainer(false);
      setAthleticsList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getAthletics(athleticsRef.current.value);
      }, 1000);
    }
    setShowAthleticsContainer(true);
  };

  const getActivities = (value) => {
    let selected = "";
    selectedActivities.map((item) => (selected += "act=" + item.id + "&"));
    GetStudentService.getActivitiesList(value, selected)
      .then((data) => {
        console.log("data from the service", data);
        setActivitiesList(data?.data?.objects);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  const getAthletics = (value) => {
    let selected = "";
    selectedAthletics.map((item) => (selected += "ath=" + item.id + "&"));
    GetStudentService.getAthleticsList(value, selected)
      .then((data) => {
        console.log("data from the service", data);
        setAthleticsList(data?.data?.objects);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  const handleSelectedActivities = (item) => {
    setActivitiesList([]);
    setShowAtivitiesContainer(false);
    activitiesRef.current.value = null;
    setActivities();
    // Check if already selected (by id or name, handling both 'name' and 'activities_name' fields)
    const itemName = item.name || item.activities_name;
    const isAlreadySelected = selectedActivities.some((selected) => {
      const selectedName = selected.name || selected.activities_name;
      return (
        (selected.id && item.id && selected.id === item.id) ||
        (selectedName && itemName && selectedName.toLowerCase() === itemName.toLowerCase())
      );
    });
    if (!isAlreadySelected) {
      setSelectedActivities([...selectedActivities, item]);
    }
  };

  const handleSelectedAthletics = (item) => {
    setAthleticsList([]);
    setShowAthleticsContainer(false);
    athleticsRef.current.value = null;
    setAthletics();
    // Check if already selected (by id or name, handling both 'name' and 'athletics_name' fields)
    const itemName = item.name || item.athletics_name;
    const isAlreadySelected = selectedAthletics.some((selected) => {
      const selectedName = selected.name || selected.athletics_name;
      return (
        (selected.id && item.id && selected.id === item.id) ||
        (selectedName && itemName && selectedName.toLowerCase() === itemName.toLowerCase())
      );
    });
    if (!isAlreadySelected) {
      setSelectedAthletics([...selectedAthletics, item]);
    }
  };

  const removeSelectedActivities = (value) => {
    let filteredValue = selectedActivities?.filter((item) => item !== value);
    setSelectedActivities(filteredValue);
  };

  const removeSelectedAthletics = (value) => {
    let filteredValue = selectedAthletics?.filter((item) => item !== value);
    setSelectedAthletics(filteredValue);
  };

  return (
    <Fragment>
      <div className="drawer-overlay" onClick={() => { setNull(); setOpenCreateStudent(false); }} />
      <div className="create-student-container">
        {/* Drawer Header */}
        <div className="drawer-header">
          <h3 className="drawer-title">
            {modify ? "Modify Student" : "New Student"}
          </h3>
          <div className="drawer-actions">
            {modify && (
              <button
                className="drawer-impersonation-btn"
                disabled={!modify?.student?.is_active}
                onClick={() => {
                  const studentData = modify?.student;
                  const counselorData = modify?.counselor;
                  const studentToken = studentData?.token;
                  
                  // Get current admin token before switching
                  const adminToken = Storage.getTokenInCookie();
                  
                  const impersonatedUserObj = {
                    ...studentData,
                    role: 'student',
                    school_id: studentData?.school || school_id,
                    student_status: studentData?.student_status || 'regular',
                    is_sch_email_verified: studentData?.is_sch_email_verified !== undefined
                      ? studentData.is_sch_email_verified
                      : true,
                    need_reflections: studentData?.need_reflections || false,
                    student_opt_out: studentData?.student_opt_out || false,
                    google_sign_in: false,
                    counselor_id: counselorData?.id || null,
                    counselor_name: counselorData?.name || null,
                    // Explicitly include profile fields
                    birth_date: studentData?.birth_date || null,
                    gender: studentData?.gender || null,
                    school_email: studentData?.school_email || studentData?.email || null,
                    school_name: studentData?.school_name || null,
                    school: studentData?.school || school_id,
                    profile_image: studentData?.profile_image || null,
                    student_id: studentData?.student_id || null,
                    country: studentData?.country || null,
                    state: studentData?.state || null,
                  };
                  
                  // Get student page state (includes search input) if available
                  let studentPageState = {};
                  try {
                    const storedPageState = localStorage.getItem('student_page_state');
                    if (storedPageState) {
                      studentPageState = JSON.parse(storedPageState);
                    }
                  } catch (e) {
                    console.error('Failed to parse student page state', e);
                  }
                  
                  // Store impersonation context in localStorage for persistence (including tokens and search state)
                  const impersonationContext = {
                    originalAdminUser: currentUser,
                    originalAdminToken: adminToken,
                    studentToken: studentToken,
                    returnSchoolId: school_id,
                    returnStudentId: studentData?.id,
                    searchInput: studentPageState.searchInput || '',
                    optionValue: studentPageState.optionValue || 'all',
                    schoolName: studentPageState.schoolName || '',
                    timestamp: new Date().toISOString(),
                  };
                  localStorage.setItem('impersonation_context', JSON.stringify(impersonationContext));
                  
                  // Set student token for API calls (x-authorization)
                  if (studentToken) {
                    Storage.setTokenInCookie(studentToken);
                  }
                  
                  dispatch(startImpersonation({
                    originalAdminUser: currentUser,
                    originalAdminToken: adminToken,
                    impersonatedStudent: impersonatedUserObj,
                    studentToken: studentToken,
                    returnSchoolId: school_id,
                    returnStudentId: studentData?.id,
                  }));
                  dispatch(userInfoAction(impersonatedUserObj));
                  localStorage.setItem('user', JSON.stringify(impersonatedUserObj));
                  const status = impersonatedUserObj.student_status;
                  const verified = impersonatedUserObj.is_sch_email_verified;
                  if (verified === true && status === 'brown') {
                    history.push('/student/brown-dashboard');
                  } else if (verified === true) {
                    history.push('/student/goal/cc-requirement');
                  } else {
                    history.push('/student/dashboard');
                  }
                }}
              >
                <span>🎭</span>
                Impersonate
              </button>
            )}
            <button
              className="drawer-close-btn"
              onClick={() => {
                setNull();
                setOpenCreateStudent(false);
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>
        {/* Counselor & Grade Section */}
        <div className="drawer-section">
          <p className="drawer-section-label">Assignment</p>
          <div className="drawer-form-row">
            <span className="form-label-col">Counselor</span>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="Type the counselor name"
                ref={counselorRef}
                onChange={counselorHandler}
                value={counselorName}
              />

              {showCounselorContainer && (
                <ul className="drawer-autocomplete">
                  {counselorList?.length > 0 &&
                    counselorList.map((item, index) => (
                      <li
                        onClick={() => handleCounselorSelect(item)}
                        key={index}
                      >
                        {item?.name}
                      </li>
                    ))}
                </ul>
              )}
              {selectedCounselor && (
                <div className="drawer-chip-list">
                  <div className="drawer-chip">
                    {selectedCounselor?.name}
                    <FontAwesomeIcon
                      icon={faTimes}
                      className="chip-remove"
                      onClick={removeCounselorName}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="drawer-form-row">
            <span className="form-label-col">
              Grade
              <FontAwesomeIcon className="required-marker" icon={faAsterisk} />
            </span>
            <div className="form-field-col">
              <select
                value={grade}
                onChange={(e) => setGrade(e.target.value)}
              >
                <option disabled selected value="">
                  Select Current Grade
                </option>
                {gradeData1.map((item, index) => (
                  <option
                    style={{ textTransform: "capitalize" }}
                    value={item?.value}
                    key={index}
                  >
                    {item?.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        {/* Personal Information */}
        <div className="drawer-section">
          <p className="drawer-section-label">Personal Information</p>
          <div className="drawer-form-row">
            <span className="form-label-col">
              First Name
              <FontAwesomeIcon className="required-marker" icon={faAsterisk} />
            </span>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
          </div>
          <div className="drawer-form-row">
            <span className="form-label-col">
              Last Name
              <FontAwesomeIcon className="required-marker" icon={faAsterisk} />
            </span>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>
        </div>
        {/* Contact Section */}
        <div className="drawer-section">
          <p className="drawer-section-label">Contact</p>
          <div className="drawer-form-row">
            <span className="form-label-col">
              Email
              <FontAwesomeIcon className="required-marker" icon={faAsterisk} />
            </span>
            <div className="form-field-col">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
              />
            </div>
          </div>
          <div className="drawer-form-row">
            <span className="form-label-col">Parent Email</span>
            <div className="form-field-col">
              <input
                type="email"
                placeholder="Parent Email"
                value={parentEmail}
                onChange={(e) => setParentEmail(e.target.value.toLowerCase())}
              />
              <p className="help-text">Email address for daily/weekly activity log to be sent</p>
            </div>
          </div>
          <div className="drawer-form-row">
            <span className="form-label-col">Secondary Email</span>
            <div className="form-field-col">
              <input
                type="email"
                placeholder="Secondary Email"
                value={recoveryEmail}
                onChange={(e) => setRecoveryEmail(e.target.value.toLowerCase())}
              />
              <p className="help-text">Used in case account needs to be recovered</p>
            </div>
          </div>
          <div className="drawer-form-row">
            <span className="form-label-col">Mobile</span>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="+19999999999"
                onChange={(e) => setMobile(e.target.value)}
                value={mobile}
              />
              <p className="help-text">Hint: +13238511115</p>
            </div>
          </div>
          <div className="drawer-form-row">
            <span className="form-label-col">Parent Mobile</span>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="+19999999999"
                value={parentMobile}
                onChange={(e) => setParentMobile(e.target.value)}
              />
              <p className="help-text">Hint: +13238511115</p>
            </div>
          </div>
          <div className="drawer-form-row">
            <span className="form-label-col">Parent Name</span>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="Parent Name"
                value={parentName}
                onChange={(e) => setParentName(e.target.value)}
              />
            </div>
          </div>
          {/* <div className="drawer-form-row">
            <span className="form-label-col">Activities</span>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="Type an activity name to add"
                onChange={handleActivitiesChange}
                ref={activitiesRef}
                value={activities}
                autoComplete="off"
              />
              {showActivitiesContainer && (
                <ul className="drawer-autocomplete">
                  {activitiesList?.length > 0 &&
                    activitiesList.map((item, index) => (
                      <li
                        onClick={() => handleSelectedActivities(item)}
                        key={index}
                      >
                        {item.name}
                      </li>
                    ))}
                </ul>
              )}
              {selectedActivities && selectedActivities.length > 0 && (
                <div className="drawer-chip-list">
                  {selectedActivities.map((item, index) => (
                    <div className="drawer-chip" key={index}>
                      {item?.name || item.activities_name}
                      <FontAwesomeIcon
                        icon={faTimes}
                        className="chip-remove"
                        onClick={() => removeSelectedActivities(item)}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="drawer-form-row">
            <span className="form-label-col">Athletics</span>
            <div className="form-field-col">
              <input
                ref={athleticsRef}
                type="text"
                placeholder="Type an athletics name to add"
                value={athletics}
                onChange={handleAthleticsChange}
                autoComplete="off"
              />
              {showAthleticsContainer && (
                <ul className="drawer-autocomplete">
                  {athleticsList?.length > 0 &&
                    athleticsList.map((item, index) => (
                      <li
                        onClick={() => handleSelectedAthletics(item)}
                        key={index}
                      >
                        {item.name}
                      </li>
                    ))}
                </ul>
              )}
              {selectedAthletics && selectedAthletics.length > 0 && (
                <div className="drawer-chip-list">
                  {selectedAthletics.map((item, index) => (
                    <div className="drawer-chip" key={index}>
                      {item?.name || item.athletics_name}
                      <FontAwesomeIcon
                        icon={faTimes}
                        className="chip-remove"
                        onClick={() => removeSelectedAthletics(item)}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div> */}
        </div>
        {/* First-in-Family Checkbox */}
        {!getCounselor ? (
          <div className="drawer-checkbox-row">
            <input
              type="checkbox"
              id="firstInFamily"
              value={firstInFamily}
              onChange={() => setFirstInFamily(!firstInFamily)}
              checked={firstInFamily}
            />
            <label htmlFor="firstInFamily">
              Please Check the Box if you are the first in your family who wants
              to attend College.
            </label>
          </div>
        ) : (
          ""
        )}

        {/* User Information Section */}
        <div className="drawer-section">
          <p className="drawer-section-label">User Information</p>
          <div className="drawer-form-row">
            <span className="form-label-col">
              Password
              <FontAwesomeIcon className="required-marker" icon={faAsterisk} />
            </span>
            <div className="form-field-col">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => passwordValidation(password)}
              />
            </div>
          </div>
          <div className="drawer-form-row">
            <span className="form-label-col">
              Confirm Password
              <FontAwesomeIcon className="required-marker" icon={faAsterisk} />
            </span>
            <div className="form-field-col">
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onBlur={() => confirmPasswordValidation(confirmPassword)}
              />
            </div>
          </div>
        </div>

        {/* Agree to Share Checkbox */}
        {!getCounselor ? (
          <div className="drawer-checkbox-row">
            <input
              type="checkbox"
              id="agreeToShare"
              value={agreeToshare}
              onChange={() => setAgreeToshare(!agreeToshare)}
              checked={agreeToshare}
            />
            <label htmlFor="agreeToShare">
              I would like to increase my chances of being recruited by a
              great university by agreeing to share my academic progress and
              goals information with them.
            </label>
          </div>
        ) : (
          ""
        )}

        {/* Merge with Student */}
        {!getCounselor
          ? modify &&
            !modify?.student?.student_id && (
              <div className="drawer-section">
                <div className="drawer-merge-row">
                  <span className="form-label-col">Merge with Student</span>
                  <input
                    type="text"
                    placeholder="Name of the student to Merge With"
                    onChange={searchHandler}
                    value={searchMergeStudent}
                  />
                  <button
                    className="drawer-merge-btn"
                    disabled={!searchMergeStudent}
                    onClick={() => setOpenMergeModal(true)}
                  >
                    <FontAwesomeIcon icon={faSave} />
                    &nbsp;Merge
                  </button>
                </div>
              </div>
            )
          : ""}
        {mergeStudentList?.length > 0 && (
          <ul className="drawer-autocomplete">
            {mergeStudentList?.map((item, index) => (
              <li
                onClick={() => {
                  setSearchMergeStudent(item.name);
                  setMergeStudentId(item.id);
                  setMergeStudentList();
                }}
                key={index}
              >
                {item.name}&nbsp;{item.email}
              </li>
            ))}
          </ul>
        )}
        {!getCounselor
          ? modify &&
            !modify?.student?.student_id && (
              <p className="help-text" style={{ marginLeft: '15px' }}>
                This student account does not have a student ID associated
                with it. Please merge it with a student that does have an ID.
              </p>
            )
          : ""}

        {showPasswordError && (
          <p style={{ color: "#e74c3c", margin: "10px 0", marginLeft: "10px", fontSize: "13px" }}>
            {showPasswordError}
          </p>
        )}

        {/* Footer Buttons */}
        <div className="drawer-footer">
          {modify && (
            <button
              className="drawer-btn-delete"
              onClick={() => setOpenDeleteModal(true)}
            >
              <FontAwesomeIcon icon={faTrash} />
              &nbsp;Delete
            </button>
          )}
          {modify && (
            <button
              onClick={updateButtonHandler}
              className="drawer-btn-save"
            >
              <FontAwesomeIcon icon={faSave} />
              &nbsp;Save
            </button>
          )}
          {!modify && (
            <button
              onClick={saveButtonHandler}
              disabled={
                !(
                  grade &&
                  email &&
                  firstName &&
                  lastName &&
                  password &&
                  confirmPassword &&
                  !showPasswordError
                )
              }
              className={
                !(
                  grade &&
                  firstName &&
                  email &&
                  lastName &&
                  password &&
                  confirmPassword &&
                  !showPasswordError
                )
                  ? "drawer-btn-save disabled"
                  : "drawer-btn-save"
              }
            >
              <FontAwesomeIcon icon={faSave} />
              &nbsp;Save
            </button>
          )}
        </div>
      </div>
      {openDeleteModal && (
        <StudentModal
          setIsOpen={setOpenDeleteModal}
          isOpen={openDeleteModal}
          data={{
            function1: deleteStudent,
            message: "Are you sure you want to delete?",
          }}
        />
      )}
      {openMergeModal && (
        <StudentModal
          setIsOpen={setOpenMergeModal}
          isOpen={openMergeModal}
          data={{
            function1: mergeStudent,
            message: "Are you sure you want to merge this student?",
          }}
        />
      )}
    </Fragment>
  );
};
export default CreateStudent;
